import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fuenteI } from '../../../modelos/fuentes.interface';
import { SuperI } from '../../../modelos/superintendecia.interface';
import { CodigoEntidadI } from '../../../modelos/codEntidad.interface'
import { TipoEntidadI } from '../../../modelos/tipoEntidad.interface';
import { DeptoI } from '../../../modelos/departamento.interface';
import { MuniI } from '../../../modelos/municipio.interface'
import { ApiService } from '../../../servicios/api/api.service';
import { AdminFuenteService } from '../../../servicios/adminfuentes/AdminFuente.service';
import { DireccionNor } from 'src/app/modelos/direccionNor';
import { ToastrService } from 'ngx-toastr';
import { FormControl, Validators } from '@angular/forms';
import { DireccionI } from 'src/app/modelos/direccion';
import { SuperTipoEntidadDTOI } from 'src/app/modelos/SuperTipoEntidaDTO';
import { VariableI } from 'src/app/modelos/variable';
import { DivipolaI } from 'src/app/modelos/Divipola';
import { HistorialFuentes } from 'src/app/modelos/fuentesdtos/HistorialFuente.interface';

@Component({
  selector: 'app-editarfuente',
  templateUrl: './editarfuente.component.html',
  styleUrls: ['./editarfuente.component.css']
})
export class EditarfuenteComponent implements OnInit {

  idUsuarioModifica: any;
  ultimaEdicion: HistorialFuentes = new HistorialFuentes;
  datosEditFuente: fuenteI;
  checkCHV: Boolean;
  checkFIVI: Boolean;
  btnguardar: Boolean;
  continuar : Boolean;
  ConsultarTipEnt : SuperTipoEntidadDTOI;
  AuxSuperintendencias : VariableI;
  AuxTipoEntidad : VariableI;
  AuxDeptoMuni : DivipolaI = new DivipolaI;

  DireccionFinal : string;
  DireccionNormalizada : DireccionNor;

  DireccionForm = {
    Via : "",
    NumNomVia : "",
    AcoNome : "",
    Prefijo : "",
    CuadranteUno : "",
    Numeral : "",
    NumPrefijoUno : "",
    LetraPrefijo : "",
    NumPrefijoDos : "",
    CuadranteDos : "",
    CompleDirec : "",
    NumLetComp : ""
  }

    NumPrefijoUnoPrueba = new FormControl('',[Validators.required]);
    tipovia = new FormControl('',[Validators.required]);
    numvia : string;
    letravia = new FormControl('',[Validators.required]);
    prefijo = new FormControl('',[Validators.required]);
    cuaduno = new FormControl('',[Validators.required]);
    numpreuno = new FormControl('',[Validators.required]);
    letpre = new FormControl('',[Validators.required]);
    numpredos : string;
    cuaddos = new FormControl('',[Validators.required]);
    complemento = new FormControl('',[Validators.required]);
    acomple : string = '';
    DireccionPrueba : DireccionI;

    @ViewChild('closeModalDireccion') closeModalDireccion: ElementRef;
    @ViewChild('openmodalconfirmar') openmodalconfirmar: ElementRef;
    @ViewChild('cerrarmodalconfirmar') cerrarmodalconfirmar: ElementRef;

  constructor(private activerouter: ActivatedRoute,
               private router: Router,
               private api: ApiService,
               private adminFuentesService: AdminFuenteService,
               private toastr: ToastrService) { }

  ngOnInit(): void {
    this.idUsuarioModifica = localStorage.getItem('id');
    let fuenteId = this.activerouter.snapshot.paramMap.get('id');
    this.ConsultarTipEnt = new SuperTipoEntidadDTOI;
    this.AuxSuperintendencias = new VariableI;
    this.AuxTipoEntidad = new VariableI;
    this.btnguardar = false;
    this.checkCHV = false;
    this.checkFIVI = false;
    this.datosEditFuente = new fuenteI;
    this.DireccionPrueba = new DireccionI;
    this.adminFuentesService.getFuenteById(fuenteId).subscribe(data=>{
      //console.log(data);
      this.datosEditFuente = data;
      this.ConsultarTipEnt.codigo = data.codTipoEntidad;
      this.ConsultarTipEnt.codsuper = data.codSuper;
      if(this.datosEditFuente.operacion.id == 1){
        this.checkCHV = true;
      } else {
        this.checkFIVI = true;
      }
      this.api.getMuniByCodigo(this.datosEditFuente.muni).subscribe(depmuni=>{
        this.AuxDeptoMuni = depmuni;
      },error=>{
        console.log(error);
      });
      this.api.getDireccionFuente(this.datosEditFuente.id).subscribe(direcc=>{
        this.DireccionPrueba = direcc;
      },error=>{
        console.log(error);
      });
      this.api.getSuperByCodigo(this.datosEditFuente.codSuper).subscribe(superin=>{
        this.AuxSuperintendencias = superin;
      });
      this.api.getTipoEntidadByCod(this.ConsultarTipEnt).subscribe(tipoent=>{
        this.AuxTipoEntidad = tipoent;
      });
      this.adminFuentesService.ultimaEdicionFuente(this.datosEditFuente).subscribe(response=>{
        this.ultimaEdicion = response;
      });
    },error=>{
      console.log(error);
    });
  }

  guardarFuente(){
    this.btnguardar = false;
    this.continuar = true;
    if (this.datosEditFuente.nombEntidad == "" || this.datosEditFuente.nombEntidad == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar razón social.', 'Advertencia!');
    } else if (this.datosEditFuente.nombEntidad.length < 5){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Razón social debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.nombEntidad.length > 100){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Razón social debe tener máximo 100 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.direccion == "" || this.datosEditFuente.direccion == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar dirección.', 'Advertencia!');
    } else if (this.datosEditFuente.direccion.length < 10){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Dirección debe tener mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.direccion.length > 100){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Dirección debe tener máximo 100 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.telefono == "" || this.datosEditFuente.telefono == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar telefono.', 'Advertencia!');
    } else if (this.datosEditFuente.telefono.length < 7){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Teléfono debe tener mínimo 7 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.telefono.length > 22){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Teléfono debe tener máximo 22 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.nombresp == "" || this.datosEditFuente.nombresp == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar nombre del responsable.', 'Advertencia!');
    } else if (this.datosEditFuente.nombresp.length < 5 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Nombre de usuario responsable debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.nombresp.length > 100 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Nombre de usuario responsable debe tener máximo 100 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.cargoresp == "" || this.datosEditFuente.cargoresp == null) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar cargo del responsable.', 'Advertencia!');
    } else if (this.datosEditFuente.cargoresp.length < 5 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Cargo de usuario responsable debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.cargoresp.length > 100 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Cargo de usuario responsable debe tener máximo 100 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.telresp == "" || this.datosEditFuente.telresp == null) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar telefono del responsable.', 'Advertencia!');
    } else if (this.datosEditFuente.telresp.length < 7 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Teléfono de usuario responsable debe tener mínimo 7 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.telresp.length > 10 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Teléfono de usuario responsable debe tener máximo 10 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.email == "" || this.datosEditFuente.email == null) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar correo del responsable.', 'Advertencia!');
    } else if (this.datosEditFuente.email.length < 5 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo de usuario responsable debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.email.length > 40 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo de usuario responsable debe tener máximo 40 caracteres.', 'Advertencia!');
    } else if (!(this.validarCorreoElectronico(this.datosEditFuente.email))) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo de usuario responsable no valido.', 'Advertencia!');
    } else if (this.datosEditFuente.nombrespInfo == "" || this.datosEditFuente.nombrespInfo == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar nombre del responsable de la información.', 'Advertencia!');
    } else if (this.datosEditFuente.nombrespInfo.length < 5 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Nombre del responsable de la información debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.nombrespInfo.length > 100 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Nombre del responsable de la información debe tener máximo 100 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.cargorespInfo == "" || this.datosEditFuente.cargorespInfo == null) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar cargo del responsable de la información.', 'Advertencia!');
    } else if (this.datosEditFuente.cargorespInfo.length < 5 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Cargo del responsable de la información debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.cargorespInfo.length > 100 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Cargo del responsable de la información debe tener máximo 100 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.telrespInfo == "" || this.datosEditFuente.telrespInfo == null) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar teléfono del responsable de la información.', 'Advertencia!');
    } else if (this.datosEditFuente.telrespInfo.length < 7 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Teléfono del responsable de la información debe tener mínimo 7 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.telrespInfo.length > 10 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Teléfono del responsable de la información debe tener máximo 10 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.emailInfo == "" || this.datosEditFuente.emailInfo == null) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar correo del responsable de la información.', 'Advertencia!');
    } else if (this.datosEditFuente.emailInfo.length < 5 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo del responsable de la información debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.datosEditFuente.emailInfo.length > 40 ) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo del responsable de la información debe tener máximo 40 caracteres.', 'Advertencia!');
    } else if (!(this.validarCorreoElectronico(this.datosEditFuente.emailInfo))) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo del responsable de la información no valido.', 'Advertencia!');
    } else {
      this.btnguardar = true;
      this.openmodalconfirmar.nativeElement.click();
    }
  }

  validarCorreoElectronico(correo): boolean {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(correo);
  }

  confirmarGuardar(){
    this.cerrarmodalconfirmar.nativeElement.click();
    this.adminFuentesService.guardarFuenteEditada(this.idUsuarioModifica, this.datosEditFuente).subscribe(data=>{
      this.toastr.success('Fuente editada.', 'OK!');
      this.router.navigate(['fuentes']);
    },error=>{
      console.log(error);
    });
  }

  cancelarConfirmar(){
    this.btnguardar = false;
  }

  regresarFuentes(){
    this.cerrarmodalconfirmar.nativeElement.click();
    this.router.navigate(['fuentes']);
  }

  NormalizandoDirecccion(){
    if (this.DireccionPrueba.tipovia == null){
      this.DireccionPrueba.tipovia = "";
    }
    if (this.DireccionPrueba.letravia == null){
      this.DireccionPrueba.letravia = "";
    }
    if (this.DireccionPrueba.prefijo == null){
      this.DireccionPrueba.prefijo = "";
    }
    if (this.DireccionPrueba.cuaduno == null){
      this.DireccionPrueba.cuaduno = "";
    }
    if (this.DireccionPrueba.letpre == null){
      this.DireccionPrueba.letpre = "";
    }
    if (this.DireccionPrueba.cuaddos == null){
      this.DireccionPrueba.cuaddos = "";
    }
    if (this.DireccionPrueba.complemento == null){
      this.DireccionPrueba.complemento = "";
    }
    if (this.DireccionPrueba.acomple == null){
      this.DireccionPrueba.acomple = "";
    }
  }

  Complemento(){
    this.DireccionPrueba.acomple = this.DireccionPrueba.acomple + " " + this.DireccionPrueba.complemento + " ";
  }

  normalizarDireccion(){
    this.DireccionPrueba.complemento = "";
    this.DireccionFinal = this.DireccionPrueba.tipovia + ' ' + this.DireccionPrueba.numvia + ' ' + this.DireccionPrueba.letravia + ' ' +
    this.DireccionPrueba.prefijo + ' ' + this.DireccionPrueba.cuaduno + ' # ' + this.DireccionPrueba.numpreuno + ' ' + this.DireccionPrueba.letpre + ' ' +
    this.DireccionPrueba.numpredos + ' ' + this.DireccionPrueba.cuaddos + ' ' + this.DireccionPrueba.acomple;

    this.datosEditFuente.direccion = this.DireccionFinal;
    this.api.guardarDireccionFuente(this.DireccionPrueba).subscribe(result=>{
    },error=>{
      console.log(error);
    });

    this.closeModalDireccion.nativeElement.click();
  }

  botonAceptarDireccion(){
    if(this.DireccionPrueba.tipovia==""|| this.DireccionPrueba.numvia==""|| this.DireccionPrueba.numpreuno==""|| this.DireccionPrueba.numpredos==""){
      return true;
    }else{
      return false;
    }

  }

}
